import { render, staticRenderFns } from "./login-form.component.vue?vue&type=template&id=1ba6c538&scoped=true"
import script from "./login-form.component.ts?vue&type=script&lang=ts&external"
export * from "./login-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./login-form.component.scss?vue&type=style&index=0&id=1ba6c538&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6c538",
  null
  
)

export default component.exports